import { SurveyTemplate } from '@/surveys/state/types';

export const it = {
  dashboard: {
    pageTitle: 'Homepage',
    welcome: {
      title: 'Ciao {{name}}!',
      description:
        'Completa la configurazione per sfruttare appieno il potere dell’AI: una volta completate le principali azioni, la dashboard con i dati raccolti sarà disponibile.',
      descriptionHasData: 'Ecco una panoramica dello stato della tua organizzazione',
    },
    noEmployees: {
      employees: {
        title: 'Aggiungi anagrafiche',
        description:
          'Carica le anagrafiche e completa i profili con le info essenziali: l’AI organizza e interpreta i dati per te.',
        cta: 'Vai a Anagrafiche',
      },
      reviewData: {
        title: 'Correggi le anagrafiche',
        description:
          'Completa e aggiorna i profili dei dipendenti: solo i profili completi possono ricevere l’assessment.',
        cta: 'Revisiona e correggi',
      },
      surveys: {
        title: 'Invia l’assessment',
        description:
          'Inizia a misurare le soft skills e raccogli i primi insight sull’organizzazione.',
        cta: 'Vai a Assessment',
      },
    },
    surveysBox: {
      title: 'Inizia ad utilizzare la piattaforma',
      steps: {
        step0: {
          title: 'Aggiungi anagrafiche',
          description:
            "Carica le anagrafiche e completa i profili con le info essenziali: l'AI organizza e interpreta i dati per te.",
          ctaLabel: 'Aggiungi anagrafiche',
        },
        step1: {
          title: 'Correggi le anagrafiche',
          description:
            'Completa e aggiorna i profili dei dipendenti: solo i profili completi possono ricevere l’assessment.',
          ctaLabel: 'Revisiona e correggi',
        },
        step2: {
          title: 'Soft skill assessment',
          description:
            'Invia il questionario delle soft skills e raccogli i primi insight sull’organizzazione. Ricorda che solo i profili completi possono ricevere l’assessment.',
          ctaLabel: 'Avvia assessment',
        },
        step3: {
          title: 'Hard skill assessment',
          description:
            'Invia il questionario delle hard skills e raccogli i primi insight sull’organizzazione. Ricorda che solo i profili completi possono ricevere l’assessment.',
          ctaLabel: 'Avvia assessment',
        },
        step4: {
          title: 'Aggiungi anagrafiche',
          description:
            'Carica le anagrafiche e completa i profili con le info essenziali: l’AI organizza e interpreta i dati per te.',
          ctaLabel: 'Aggiungi anagrafiche',
        },
      },
      cta: 'Vai a Assessment',
    },
    overview: {
      title: 'Overview aziendale',
      current: {
        title: 'Totale anagrafiche',
        tooltip: 'Totale anagrafiche caricate nel sistema, comprese quelle incomplete',
      },
      validProfile: {
        title: 'Profili completi',
        tooltip: 'Anagrafiche con tutte le informazioni essenziali complete',
      },
      invalidProfile: {
        title: 'Profili da correggere',
        tooltip: 'Anagrafiche con informazioni mancanti o incomplete',
      },
      noInvalid: {
        text1: 'Tutti i profili sono stati caricati correttamente! ',
        text2: "Procedi con l’invio dell'assessment",
      },
      cta: {
        fixProfiles: 'Revisiona e correggi',
        goToPeople: 'Vai a Anagrafiche',
      },
      departments: {
        title: 'Dipartimenti',
        cta: 'Vai a Dipartimenti',
        noDepartmentName: 'Senza nome',
      },
    },
    overviewSurveys: {
      title: 'Overview assessment',
      description:
        'Seleziona un questionario tra quelli sotto elencati per vedere il suo punteggio medio. ',
      results: {
        title: 'Risposte {{surveyTemplateName}} assessment',
        description: {
          singular: '{{total}} questionario inviato',
          plural: '{{total}} questionari inviati',
        },
        cta: 'Vai a {{surveyTemplateName}} assessment',
        completed: 'Completati',
        notCompleted: 'Da completare',
        completionRate: 'Tasso completamento',
        info: {
          noData:
            'Non sono ancora presenti risultati: la dashboard sarà visibile solo quando sarà raccolta almeno una risposta',
        },
        completedBox: {
          title: 'Punteggio medio per {{surveyTemplateName}}',
          description:
            'Il grafico riporta i punteggi medi (scala 0-7) sulle {{metricsCount}} {{surveyTemplateName}}, considerate fondamentali per affrontare in modo efficace le sfide dell’AI.',
        },
      },
    },
    learning: {
      title: 'Ciao {{firstName}}!',
      description: {
        hasNeverCompletedSurveys:
          'Non hai ancora completato nessun assessment. Completa il primo assessment per visualizzare i tuoi risultati e ottenere insights personalizzati sulle tue competenze.',
        hasNotCompletedSurveys:
          'Completa gli assessment per ottenere insights sulle tue competenze e aree di sviluppo',
        hasCompletedSurveys: 'Ottimo lavoro! Esplora i tuoi prossimi passi',
      },
      surveyNotCompleted: {
        title: 'Completa i tuoi assessment',
        steps: {
          title: 'Assessment da completare',
          description: {
            [SurveyTemplate.SoftSkillAssessment]:
              'Un questionario di 15 minuti progettato per misurare le soft skills chiave — come creatività, problem solving, collaborazione ed empatia — delle tua azienda e restituire un profilo personalizzato. I risultati ti permettono di conoscere i punti di forza, individuare aree di miglioramento e confrontarli con i trend aziendali.',
            [SurveyTemplate.HardSkillAssessment]:
              'Un questionario di 15 minuti pensato per misurare il livello di maturità nelle competenze tecniche generiche legate alla gestione dell’AI. I risultati ti permettono di conoscere i punti di forza, individuare aree di miglioramento e confrontarli con i trend aziendali.',
          },
          ctaLabel: 'Avvia assessment',
        },
      },
      surveyResults: {
        title: {
          moreThanOne: 'Assessment completati',
          single: 'Actual Profile - {{surveyTemplateName}}',
        },
        description:
          'Il grafico riporta il tuo punteggio medio (scala 0-7) sulle {{metricsCount}} {{surveyTemplateName}}, considerate fondamentali per affrontare in modo efficace le sfide dell’AI.',
        insightBox: {
          title: 'Insight',
          proTitle: 'Punti di forza',
          conTitle: 'Punti di debolezza',
        },
      },
      noResultsVisible: {
        description:
          'Hai completato l’assessment dedicato alla valutazione delle metriche dell’assessment {{surveyTemplateName}}. \nEsplora i contenuti disponibili e approfondisci le aree che più ti interessano nella sezione Training.',
        buttonLabel: 'Esplora il training',
      },
      courses: {
        title: 'Corsi per te',
        description: 'Scopri subito i corsi pensati per sviluppare le tue soft skills.',
      },
      teamDepartment: {
        title: 'Team',
        noDepartmentName: 'Senza nome',
        cta: 'Vai al dipartimento',
        ctaViewTeam: 'Visualizza',
      },
      teamList: {
        title: 'Componenti team',
        cta: 'Vai al team',
      },
      tutorial: {
        employee: {
          title: 'Benvenuto su Slash',
          slides: {
            slide1: {
              title: 'Visualizza i risultati dei tuoi assessment',
              description:
                'Dalla Homepage puoi consultare i risultati dei tuoi assessment. Questo ti offre una visione chiara del livello complessivo di readiness e ti aiuta a individuare le aree su cui concentrarti per sviluppare le tue skill al meglio.',
            },
            slide2: {
              title: 'Chiedi al tuo AI assistant',
              description:
                'Il tuo AI assistant è disponibile per rispondere alle tue domande relative alla piattaforma.',
            },
            slide3: {
              title: 'Dai uno sguardo ai tuoi risultati',
              description:
                'Accedi alla sezione dei tuoi assessment per consultare i dati aggregati e confrontare i tuoi risultati con quelli del team, individuando punti di forza e aree di miglioramento.',
            },
            slide4: {
              title: 'Esplora la sezione Training',
              description:
                'La sezione Training è il tuo punto d’accesso ai percorsi formativi di Slash. Qui trovi un’area dedicata allo sviluppo delle soft skill, con attività e workshop in presenza, e una sezione pensata per potenziare le tue hard skill direttamente in piattaforma, attraverso video pillola, contenuti PDF e quiz interattivi.',
            },
          },
        },
        manager: {
          title: 'Benvenuto su Slash',
          slides: {
            slide1: {
              title: 'Visualizza i risultati dei tuoi assessment',
              description:
                'Dalla Homepage puoi consultare i risultati dei tuoi assessment. Questo ti offre una visione chiara del tuo livello di readiness e ti aiuta a individuare le aree su cui concentrarti per sviluppare al meglio le tue skill.',
            },
            slide2: {
              title: 'Visualizza i risultati del tuo dipartimento',
              description:
                'Nella sezione Il mio dipartimento puoi esplorare i risultati aggregati del tuo dipartimento e dei team sottostanti: confronta i punteggi con la media aziendale, visualizza le singole soft skills e il posizionamento di ciascun collaboratore.',
            },
            slide3: {
              title: 'Dai uno sguardo ai tuoi risultati',
              description:
                'Accedi alla sezione dei tuoi assessment per consultare i dati aggregati e confrontare i tuoi risultati con quelli del tuo  dipartimento e dell’intera organizzazione, individuando punti di forza e aree di miglioramento.',
            },
            slide4: {
              title: 'Esplora la sezione Training',
              description:
                'La sezione Training è il tuo punto d’accesso ai percorsi formativi di Slash. Qui trovi un’area dedicata allo sviluppo delle soft skill, con attività e workshop in presenza, e una sezione pensata per potenziare le tue hard skill direttamente in piattaforma, attraverso video pillola, contenuti PDF e quiz interattivi.',
            },
            slide5: {
              title: 'Chiedi al tuo AI assistant',
              description:
                'Il tuo AI assistant è disponibile per rispondere alle tue domande relative alla piattaforma.',
            },
          },
        },
        team: {
          title: 'Benvenuto su Slash',
          slides: {
            slide1: {
              title: 'Visualizza i risultati dei tuoi assessment',
              description:
                'Dalla Homepage puoi consultare i risultati dei tuoi assessment. Questo ti offre una visione chiara del livello complessivo di readiness e ti aiuta a individuare le aree su cui concentrarti per sviluppare le tue skill al meglio.',
            },
            slide2: {
              title: 'Visualizza i risultati del tuo team',
              description:
                'Accedi alla sezione Il mio team per visualizzare i punteggi medi e individuali dei membri del gruppo, confrontarli con la media di dipartimento e individuare punti di forza e margini di miglioramento.',
            },
            slide3: {
              title: 'Dai uno sguardo ai tuoi risultati',
              description:
                'Accedi alla sezione dei tuoi assessment per consultare i dati aggregati e confrontare i tuoi risultati con quelli del team e del dipartimento, individuando punti di forza e aree di miglioramento.',
            },
            slide4: {
              title: 'Esplora la sezione Training',
              description:
                'La sezione Training è il tuo punto d’accesso ai percorsi formativi di Slash. Qui trovi un’area dedicata allo sviluppo delle soft skill, con attività e workshop in presenza, e una sezione pensata per potenziare le tue hard skill direttamente in piattaforma, attraverso video pillola, contenuti PDF e quiz interattivi.',
            },
            slide5: {
              title: 'Chiedi al tuo AI assistant',
              description:
                'Il tuo AI assistant è disponibile per rispondere alle tue domande relative alla piattaforma.',
            },
          },
        },
      },
    },
  },
};
